require([
    'application',
    'config/routes',
    'config/application',
    'views/demo-dialog',
    'dtBootstrap',
    'dtScroller'
], function(Application, routes, applicationConfig, DemoDialog) {
    'use strict';

    window.app = new Application({
        routes: routes,
        pushState: false,
        controllerSuffix: applicationConfig.controllerSuffix
    });

    window.app.onShowDemoDialog = function(ev) {
        DemoDialog.show();
        if (ev) {
            ev.stopPropagation();
            ev.preventDefault();
        }
        return false;
    };
});

window.log = function() {
    'use strict';

    try {
        return window.console.log.apply(window.console, arguments);
    } catch (error) {}
};
define("initialize", function(){});

